import { Avatar } from '../../primitives';

import { EM_DASH } from './upcomingWorkshopsFormat';

export function WorkshopCrewCell({ name }: { name: string }) {
  if (!name) {
    return <span style={{ color: 'var(--nb-faint)' }}>{EM_DASH}</span>;
  }
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <Avatar name={name} size={22} />
      <span style={{ fontWeight: 600 }}>{name}</span>
    </div>
  );
}
